import intlTelInput from 'intl-tel-input/intlTelInputWithUtils'

// Extract country code from browser locale (e.g. "tr-TR" → "TR")
const countryFromLocale = () => {
  const locale = navigator.language || ''
  const parts = locale.split('-')
  return parts.length >= 2 ? parts[parts.length - 1].toUpperCase() : ''
}

// Try Cloudflare trace (always works, no auth/rate limits)
const fetchCloudflare = () =>
  fetch('https://cloudflare.com/cdn-cgi/trace')
    .then((res) => res.text())
    .then((text) => {
      const match = text.match(/^loc=([A-Z]{2})/m)
      return match ? match[1] : ''
    })

const initTel = (input) => {
  const iti = intlTelInput(input, {
    initialCountry: 'auto',
    geoIpLookup: function (success) {
      fetch('https://ipapi.co/json')
        .then((res) => res.json())
        .then((data) => success(data.country_code || ''))
        .catch(() =>
          fetchCloudflare()
            .then((code) => success(code || countryFromLocale()))
            .catch(() => success(countryFromLocale()))
        )
    },
  })

  if (!window.bhubIti) {
    window.bhubIti = iti
  }
  return iti
}

export default initTel
